import {EntitiesState} from 'app/blocks/store/states/entities-state';
import {CommonState} from 'app/blocks/store/states/common-state';

export const appStates = [EntitiesState, CommonState];
